import { formatDistanceToNow } from 'date-fns'
import { LOCALE_TO_DATE_FNS, toAppLocale } from './locale'

/**
 * «5 минут назад» на языке интерфейса.
 *
 * `lang` не имеет дефолта намеренно: он тут был (`'ru'`), и вызов без него
 * молча печатал русский текст в английском интерфейсе — так и случилось в
 * карточке тикета. Обязательный параметр заставляет подумать, чей это язык.
 */
export function timeAgo(dateString: string, lang: string): string {
  return formatDistanceToNow(new Date(dateString), {
    locale: LOCALE_TO_DATE_FNS[toAppLocale(lang)],
    addSuffix: true,
  })
}
